/**
 * WatchHistoryTabContent — literal iOS "Coming Soon" placeholder.
 * Web port of client-native/src/features/profile/components/WatchHistoryTabContent.tsx.
 */
import { FC } from "react";
import { Clock } from "lucide-react";
import { colors } from "@/ui";

const WatchHistoryTabContent: FC = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "32px 32px 0",
      textAlign: "center",
    }}
  >
    <Clock size={64} color={colors.greyLightest} style={{ marginBottom: 16 }} />
    <span className="text-lg font-semibold" style={{ color: colors.secondary }}>
      Coming Soon
    </span>
    <span className="text-base" style={{ color: colors.muted, marginTop: 8 }}>
      Your watch history will appear here
    </span>
  </div>
);

export default WatchHistoryTabContent;
